import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useButtonStyles from "../../styles/useButtonStyles";
import theme from "../../theme";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import { useDispatch } from "react-redux";
import { adminActions } from "../../redux/slices/adminSlice";
import { useAppSelector } from "../../redux/hooks";
import BasicModal from "../ui/BasicModal";
import formatDate from "../../util/dateFormat";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { AddUser } from "./AddUser";
import { AddAdminData } from "../../static-models/AdminFormData";
import UpdateUser from "./UpdateUser";
import { UpdateUserDetails } from "./UpdateUserDetails";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { getEncodedLastkey, getEncodedValue } from "../forms/utility";
import {
  SearchToolTip,
  filterConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
}
const columns: TableColumn[] = [
  { key: "firstName", header: "First Name" },
  { key: "lastName", header: "Last Name" },
  { key: "email", header: "Email" },
  { key: "userRole", header: "User Role" },
  { key: "status", header: "Status" },
  { key: "lastLogin", header: "Last Login" },
];
const listOfStatus = [filterConstants.Active, filterConstants.Inactive];
export function Users() {
  const { getUserPermission: getAccessManagement } = usePermissionGetter(
    permissionsConstants.admin,
    permissionsConstants.access_management
  );
  const { getUserPermission: getUserPermissions } = usePermissionGetter(
    permissionsConstants.admin,
    permissionsConstants.user
  );
  const buttonStyles = useButtonStyles();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [addUser, setAddUser] = useState(false);
  const [updateUser, setUpdateUser] = useState(false);
  const [updateUserDetails, setUpdateUserDetails] = useState(false);
  const [apiCall, setApiCall] = useState(true);
  const [lastKey, setLastKey] = useState(null);
  const [user, setUser] = useState<any>({});
  const [adminData, setAdminData] = useState([]);
  const [filterActive, setFilterActive] = useState(false);

  const dispatch = useDispatch();
  const adminList = useAppSelector(
    (state: any) => state.persistReducers.getAdminList.adminList
  );
  const searchInputRef = useRef<HTMLInputElement>();
  const params = useParams();
  const { userId } = params;
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();

  useEffect(() => {
    if (userId) {
      const singleUser = adminList.filter((user: any) => user?.id === userId);
      const sUser = singleUser[0];
      setUser(sUser);
      setUpdateUser(true);
    }
  }, [userId]);
  const fetchAdminList = async (url: string, canMergeData?: boolean) => {
    let currentURl = url;
    try {
      setLoading(true);
      // getTotalCounts(currentURl, "data.result.data");
      if (lastKey)
        currentURl +=
          (currentURl.includes("?") ? "&" : "?") + getEncodedLastkey(lastKey);
      const response = await axios.get(currentURl);
      const data = response.data.result.data;
      const apiKey = response.data.result.lastKey
        ? response.data.result.lastKey
        : null;
      setLastKey(apiKey);
      const adminlistData = data.map((item: any) => {
        return {
          email: item.email ? item.email : "-",
          firstName: item.firstName ? item.firstName : "-",
          lastName: item.lastName ? item.lastName : "-",
          status: item.status ? item.status : "-",
          userRole: item.user_role ? item.user_role : "-",
          department: item.department ? item.department : "-",
          lastLogin: item.lastLogin ? formatDate(item.lastLogin) : "-",
          createdAt: item.createdAt ? formatDate(item.createdAt) : "-",
          id: item?.id ? item.id : "-",
          navigateTo: item.id ? `/admin/CU/${item.id}` : "-",
        };
      });
      adminlistData.sort(
        (
          a: { createdAt: string | number | Date },
          b: { createdAt: string | number | Date }
        ) => {
          const dateA = new Date(a.createdAt).getTime();
          const dateB = new Date(b.createdAt).getTime();
          return dateB - dateA;
        }
      );
      const dataToSet = canMergeData
        ? [...adminData, ...adminlistData]
        : adminlistData;
      setAdminData(dataToSet);
      dispatch(adminActions.updateAdminList({ membersList: dataToSet }));
      setLoading(false);
      setError(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setError(true);
    } finally {
      setApiCall(false);
    }
  };
  useEffect(() => {
    if (apiCall) bindSearchAndFilter();
  }, [apiCall]);

  const bindSearchAndFilter = (canMergeData?: boolean) => {
    const hashValue = {
      field: "userType",
      value: "admin",
    };
    const searchValue = searchInputRef.current
      ? searchInputRef.current.value
      : "";
    const searchParam =
      searchValue !== "" ? [getEncodedValue(searchValue)] : [];
    const params = {
      hashData: hashValue,
      searchData: searchParam,
      filterData: filterStates,
    };
    const url = getHashURL(params);
    let newURL = `${process.env.REACT_APP_API_URL + APIConstants.admin}?${url}`;
    newURL += `&module=admin&feature=user`;

    if (adminData.length === 0)
      getTotalRecordsCount(APIModuleConstants.adminUser, url);
    fetchAdminList(newURL, canMergeData);
  };
  const handleUpdate = () => {
    setUpdateUser(false);
    setUpdateUserDetails(true);
  };
  const NavigateToAdmin = () => {
    setUpdateUser(false);
    setUpdateUserDetails(false);
    navigate("/admin");
  };

  // Filters and Search UI
  const [roles, setRoles] = useState<string[]>([]);
  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.role + "?type=Admin"
        );
        const data = response.data.data;

        const roleListData = data.map((item: any) => {
          return {
            name: item.name ? item.name : "-",
            description: item.description ? item.description : "-",
          };
        });

        const roles = data.map((item: any) => {
          return item.name;
        });
        setRoles(roles);
      } catch (error) {
        console.error(error);
      }
    };

    fetchRoleList();
  }, []);

  const [openFilter, setOpenFilter] = useState(false);

  const [filterState, setFilterState] = useState({
    userRole: "",
    status: "",
  });

  const resetFilterState = () => {
    setFilterState({
      userRole: "",
      status: "",
    });
    setFilterStates([]);
    onResetData();
    setApiCall(true);
    setFilterActive(false);
  };
  const handleClose = () => {
    setOpenFilter(false);
  };
  const [filterStates, setFilterStates] = useState<any>([]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const HandleRoleChange = (event: SelectChangeEvent) => {
    getAllFields(
      "user_role",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      userRole: event.target.value,
    }));
  };
  const HandleStatusChange = (event: SelectChangeEvent) => {
    getAllFields(
      "status",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };
  const applyShopUserFilter = () => {
    onResetData();
    setOpenFilter(false);
    setApiCall(true);
    const anyFilterActive = Object.values(filterState).some(
      (value) => value !== ""
    );
    if (anyFilterActive) {
      setFilterActive(true);
    }
  };
  // search
  const handleSearch = () => {
    onResetData();
    setApiCall(true);
  };

  const onResetData = () => {
    setLastKey(null);
    setAdminData([]);
  };
  return (
    <Grid container>
      <Grid
        item
        display={"flex"}
        justifyContent={"space-between"}
        p={4}
        sx={{ background: theme.color?.background }}
        width={"100%"}
      >
        <Grid>
          {getAccessManagement("read") && (
            <Button
              sx={{ ...buttonStyles.outlinedSecondary, mr: 2 }}
              variant="outlined"
              component={Link}
              to="/roles"
            >
              Access Management
            </Button>
          )}
          {getUserPermissions("create") && (
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              variant="contained"
              onClick={() => setAddUser(true)}
            >
              Add Users
            </Button>
          )}
        </Grid>
        <Drawer
          anchor={"right"}
          open={addUser}
          onClose={() => {
            setAddUser(false);
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"40vw"} height={"100%"}>
            <AddUser
              initialFormData={AddAdminData}
              closeAddUser={setAddUser}
              fetchAdminList={() => {
                onResetData();
                setApiCall(true);
              }}
            />
          </Grid>
        </Drawer>
        <Drawer
          anchor={"right"}
          open={updateUser}
          onClose={() => {
            NavigateToAdmin();
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"40vw"} height={"100%"}>
            <UpdateUser
              user={user}
              closeDrawer={setUpdateUser}
              onRefresh={() => {
                onResetData();
                setApiCall(true);
              }}
              openUpdate={handleUpdate}
            />
          </Grid>
        </Drawer>
        <Drawer
          anchor={"right"}
          open={updateUserDetails}
          onClose={() => {
            NavigateToAdmin();
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"40vw"} height={"100%"}>
            <UpdateUserDetails
              user={user}
              fetchAdminList={() => {
                onResetData();
                setApiCall(true);
              }}
              initialFormData={AddAdminData}
              closeUpdateUserDetails={setUpdateUserDetails}
            />
          </Grid>
        </Drawer>
        <Grid>
          {getUserPermissions("read") && (
            <Grid display={"flex"} gap={3}>
              <SearchInput
                HelpTip={SearchToolTip.Users}
                onCallBack={handleSearch}
                ref={searchInputRef}
              />
              <Button
                variant="text"
                startIcon={
                  filterActive ? (
                    <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                  ) : (
                    <FilterAltOutlinedIcon />
                  )
                }
                sx={{
                  color: theme.color?.newFilterGrey,
                  textTransform: "capitalize",
                }}
                onClick={() => setOpenFilter(true)}
              >
                Filter
              </Button>
            </Grid>
          )}
        </Grid>
        <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
          <Grid sx={{ width: "484px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              {/* <IconButton onClick={() => setOpenFilter(false)}> */}
              <IconButton
                onClick={() => {
                  setOpenFilter(false);
                }}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Role
                  </Typography>
                  <Grid
                    gap={2}
                    mt={2}
                    display={"flex"}
                    sx={{
                      width: "80%",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        with: "100%",
                      }}
                    >
                      <Select
                        id=""
                        value={filterState.userRole}
                        onChange={HandleRoleChange}
                      >
                        {roles.map((name: any) => (
                          <MenuItem value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Status
                  </Typography>
                  <Grid
                    gap={2}
                    mt={2}
                    display={"flex"}
                    sx={{
                      width: "80%",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        with: "100%",
                      }}
                    >
                      <Select
                        id=""
                        value={filterState.status}
                        onChange={HandleStatusChange}
                      >
                        {listOfStatus.map((name: any) => (
                          <MenuItem value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={resetFilterState}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={applyShopUserFilter}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      </Grid>

      {getUserPermissions("read") && (
        <Grid mt={2} padding={2} justifySelf={"center"} width={"100%"}>
          <InfiniteTable
            header={columns}
            contentItems={adminData}
            fetchMoreData={() => bindSearchAndFilter(true)}
            hasMoreRecords={lastKey !== null}
            isInitialLoading={loading && adminData.length === 0}
            totalRecords={totalCount}
          />
        </Grid>
      )}

      {error && (
        <BasicModal
          title={"Something went wrong"}
          success={false}
          setState={setError}
        />
      )}
    </Grid>
  );
}
